import { createActionGroup, emptyProps, props } from "@ngrx/store";
import { PaginationParam } from "daisy-design-system-front";
import {SearchExportRequests$Json$Params} from '../../../../swagger-gen/web-secured/fn/reporting/search-export-requests-json';
import {PagingAttributes} from '../../../../swagger-gen/web-secured/models/paging-attributes';
import {MappedExportRequest} from '../../../models/export-requests/export-request.models';
import {ExportRequestCreate} from '../../../../swagger-gen/web-secured/models/export-request-create';
import {ExportRequestGenericOntology} from '../../../../swagger-gen/web-secured/models/export-request-generic-ontology';
import {OntologyType} from '../../../shared/models';
import {UpdateExportRequest$Params} from '../../../../swagger-gen/web-secured/fn/reporting/update-export-request';



export const ExportRequestsActions = createActionGroup({
  source: "[Export Requests]",
  events: {
    Search: props<{filter: SearchExportRequests$Json$Params, currentPage: number}>(),
    Fetch: props<PaginationParam>(),
    "loader Start": emptyProps(),
    "Fetch Success": props<{ response: {paging: PagingAttributes, list: Array<MappedExportRequest>} }>(),
    "Fetch Failure": props<{ message: string }>(),
    "Refresh Data": emptyProps(),
    "Update Active": props<{uid: string, active: boolean}>(),

    "Create Request": props<{ exportRequestParam: ExportRequestCreate, ontologies: {ontology: ExportRequestGenericOntology, type: OntologyType}[], toExecute: boolean }>(),
    "Create Request Success": emptyProps(),
    "Create Request Failure": props<{ message: string }>(),

    "Create Request ontologies": props<{exportRequestUid: string, ontologies: {ontology: ExportRequestGenericOntology, type: OntologyType}[], toExecute: boolean }>(),
    "Create Request ontologies Success": emptyProps(),
    "Create Request ontologies Failure": props<{ message: string }>(),

    "Configured": props<{ exportRequestUid: string }>(),
    "Create Request Configured Success": emptyProps(),
    "Create Request Configured Failure": props<{ message: string }>(),

    "Fetch Children": props<{ exportRequestUid: string }>(),
    "Download": props<{ exportRequestUid: string, exportRequestName: string }>(),
    "Delete": props<{ exportRequestUid: string }>(),
    "Clone": props<{ exportRequestUid: string }>(),

    "Retry": props<{ exportRequestUid: string }>(),
    "Retry Success": props<{ message: string }>(),
    "Retry Failure": props<{ message: string }>(),

    "Update Request": props<{ exportRequestParam: UpdateExportRequest$Params, ontologies?: {ontology: ExportRequestGenericOntology, type: OntologyType, fullPath: string}[], toExecute: boolean }>(),
    "Update Success": emptyProps(),
    "Update Failure": props<{ message: string }>(),

    "Duplicate Request": props<{ exportRequestUid: string }>(),
    "Duplicate Success": emptyProps(),
    "Duplicate Failure": props<{ message: string }>(),

    Clean: emptyProps(),
  },
});

